<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Order Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="order_date_from"/> ~ <CustomDatePicker v-model="order_date_to"/></span>

				<em class="lt_text">Status</em>
				<span class="mgr_5">
					<select v-model="order_status" class="tbl_select ssm_int">
						<option :value="null">All</option>
						<option value="O">Order</option>
						<option value="A">Accept</option>
						<option value="R">Reject</option>
					</select>
				</span>

				<span class="int_type_no_border mgl_15 mgr_15">
					<PartnerSelect ph="Ship To" v-model.trim="ship_to_code" :showName="true" @set-partner="setPartner" />
				</span>

				<span class="int_type_no_border">
					<SalesGroup v-model="selected_sales_group" :allSelect="false" />
				</span>

				<a href="javascript:;" class="search_bt mgl_15" @click="gotoPage(1)">Search</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<colgroup>
				<col style="width: 2%" />
				<col style="width: 5%" />
				<col style="width: 6%" />
				<col style="width: 8%" />
				<col style="width: 8%" />
				<col style="width: 7%" />
				<col style="width: 5%" />
				<col style="width: 12%" />
				<col style="width: 24%" />
				<col style="width: 7%" />
				<col style="width: 7%" />
				<col style="width: 4%" />
				<col style="width: 5%" />
			</colgroup>
			<thead>
				<tr>
					<th><input type="checkbox" @change="allCheck" /></th>
					<th>Order No</th>
					<th>Order State</th>
					<th>Order Date</th>
					<th>Process Date</th>
					<th>Sales Group</th>
					<th>Cus Code</th>
					<th>Cus Name</th>
					<th>Ship Address</th>
					<th>SO_No</th>
					<th>Invoice_No</th>
					<th>Qty</th>
					<th>Amount($)</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(order, index) in order_list" :key="index" :class="{ red_background: order.out_of_stock_yn === 'Y' }" :title="order.out_of_stock_yn === 'Y' ? 'Out of quantity for some items' : null">
					<td class="al_center"><input v-if="order.order_status === 'O'" type="checkbox" :value="order.order_no" v-model="selected_list" /></td>
					<td>
						<a href="javascript: void(0);" @click="gotoDetail(order.order_no)">{{ order.order_no | fillZeroForDisplayNo(8) }}</a>
					</td>
					<td>
						<span v-if="order.invoice_no">{{ order.invoice_status | saleStatusName }}</span>
						<span v-else-if="order.order_status === 'O'">Before Accept</span>
						<span v-else-if="order.order_status === 'R'">Reject</span>
					</td>
					<td>{{ order.crt_dt }}</td>
					<td>{{ order.process_dt }}</td>
					<td>{{ order.sales_group_description || order.sales_group_name || order.sales_group_code }}</td>
					<td>{{ order.partner_code }}</td>
					<td class="truncate">{{ order.partner_name }}</td>
					<td class="truncate">{{ order.address }}</td>
					<td>
						<a href="javascript: void(0);" @click="selectInvoice(order.invoice_no)">{{ order.so_dn }}</a>
					</td>
					<td>
						<a href="javascript: void(0);" @click="selectInvoice(order.invoice_no, 'invoice')">{{ order.invoice_dn }}</a>
					</td>
					<td class="al_right">{{ order.order_qty | commaSeparated }}</td>
					<td class="al_right">{{ order.order_amount | toCurrency }}</td>
				</tr>
			</tbody>
		</table>

		<Paging ref="paging" v-on:gotoPage="gotoPage" />

		<div class="bottom_bt_box">
			<ul v-if="modifiable">
				<li>
					<a href="javascript:;" class="gray_bt" @click="acceptRetailOrders">Accept</a>
				</li>
				<li>
					<a href="javascript:;" class="gray_bt" @click="openRejectModal">Reject</a>
				</li>
			</ul>
		</div>

		<RejectModal v-if="reject_modal" @close="closeRejectModal" @reject="rejectRetailOrders" />
	</div>
</template>

<script>
import RejectModal from '@/views/sales/retailStore/RejectModal';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import SalesGroup from '@/components/common/SalesGroup';
import { today, daysAgo } from '@/utils/date.js';
import { apiSelectRetailOrderListInAdm, apiAcceptRetailOrders, apiRejectRetailOrders } from '@/api/sales/retail.js';
export default {
	data: () => ({
		// 페이지 처리
		paging_yn: 'Y',
		page_size: 25,
		page_no: 1,
		list_count: 0,

		// 화면 상단 검색조건
		order_date_from: daysAgo(6),
		order_date_to: today(),
		ship_to_code: null,
		order_status: null,
		selected_sales_group: null,

		// 화면 출력 리스트
		order_list: [],

		// 선택된 리스트 요소의 orderNo 배열
		selected_list: [],

		// URL 쿼리 스트링
		query: ['ship_to_code', 'order_status', 'order_date_from', 'order_date_to', 'selected_sales_group', 'paging_yn', 'page_size', 'page_no'],
		uri: '',

		// 주문 거절 시 출력 모달
		reject_modal: false,
	}),
	components: {
		CustomDatePicker,
		PartnerSelect,
		Paging,
		RejectModal,
		SalesGroup,
	},
	computed: {
		modifiable: {
			get: function() {
				let menus = this.$session.get('menus');
				for (let menu of menus) {
					// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
					if (menu.path === this.$router.history.current.path && menu.modify_yn === 'Y') return true;
				}
				return false;
			},
		},
	},
	methods: {
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectRetailOrder();
		},
		setPage() {
			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
		},
		setPartner(partner) {
			this.ship_to_code = partner.code;
		},
		gotoDetail(order_no) {
			// console.log(this.$route.fullPath);
			this.$router.push({ name: 'retailDetail', query: { order_no, back_uri: this.uri || this.$route.fullPath } });
		},
		openRejectModal() {
			if (!this.selected_list.length) {
				this.$toast.error('Please Check Order To Reject.');
				return;
			}

			this.reject_modal = true;
		},
		closeRejectModal() {
			this.reject_modal = false;
		},
		allCheck(event) {
			let selected_list = [];
			if (event.target.checked) {
				this.order_list.forEach(el => {
					if (el.order_status === 'O') selected_list.push(el.order_no);
				});
			}

			this.selected_list = selected_list;
		},
		selectInvoice(invoice_no, type) {
			let routeData;
			if (type == 'invoice') {
				// this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri || this.$route.fullPath, invoice_no } });
				window.open(routeData.href, 'herp_invoice');
				// this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
			} else {
				routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri || this.$route.fullPath, invoice_no } });
				window.open(routeData.href, 'herp_so');
			}

			//let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
			//window.open(routeData.href, '_blank');
		},
		async acceptRetailOrders() {
			if (!this.selected_list.length) {
				this.$toast.error('Please Check Order To Accept');
				return;
			}

			let { data } = await apiAcceptRetailOrders(this.selected_list);
			if (data > 0) {
				this.selected_list = [];
				this.$toast.success('Success To Accept Orders');

				await this.selectRetailOrder();
			} else this.$toast.error('Nothing To Accept');
		},
		async rejectRetailOrders(status_reason) {
			let { data } = await apiRejectRetailOrders(this.selected_list, status_reason || null);
			if (data > 0) {
				this.selected_list = [];
				this.$toast.success('Success To Reject Orders');
				this.closeRejectModal();

				await this.selectRetailOrder();
			} else this.$toast.error('Nothing To Reject');
		},
		makeQueryString() {
			let queryString = this.$route.path;
			let isAdded = false;
			for (let prop of this.query) {
				if (this.$data[prop]) {
					if (isAdded) {
						queryString += '&';
					} else {
						queryString += '?';
						isAdded = true;
					}

					queryString += prop + '=' + this.$data[prop];
				}
			}

			// this.$router.replace(queryString).catch(err => err);
			window.history.replaceState({}, null, queryString);
			this.uri = queryString;
		},
		async selectRetailOrder() {
			let { data } = await apiSelectRetailOrderListInAdm(this.ship_to_code || null, this.order_status, this.order_date_from, this.order_date_to, this.selected_sales_group, this.paging_yn, this.page_size, this.page_no);
			if (data.list && data.list.length > 0) {
				data.list.forEach(el => {
					el.address =
						(el.shipped_address_detail ? el.shipped_address_detail + ', ' : '') +
						(el.shipped_address_city ? el.shipped_address_city + ', ' : '') +
						(el.shipped_address_state ? el.shipped_address_state + ', ' : '') +
						(el.shipped_address_country ? el.country_name || el.shipped_address_country : '') +
						(el.shipped_zipcode ? '(' + el.shipped_zipcode + ')' : '');
				});

				this.order_list = data.list;
			} else this.order_list = [];

			this.list_count = data.count;

			this.setPage();
			this.makeQueryString();
		},
		async init() {
			for (let prop of this.query) {
				if (this.$route.query[prop]) this.$data[prop] = this.$route.query[prop];
			}

			await this.selectRetailOrder();
		},
	},
	created() {
		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_retail');
		this.$store.commit('setSubTitle', 'Sales -> Retail Store');

		this.init();
	},
};
</script>

<style scoped>
.red_background td {
	background: #ff8800 !important;
}
.red_background:hover td {
	background: #ffc300 !important;
}
</style>
